/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { HolderBonus, HolderBonusFromJSON, HolderBonusFromJSONTyped, HolderBonusToJSON } from './HolderBonus'

/**
 *
 * @export
 * @interface HolderBonusesResponse
 */
export interface HolderBonusesResponse {
  /**
   *
   * @type {Array<HolderBonus>}
   * @memberof HolderBonusesResponse
   */
  items?: Array<HolderBonus>
}

export function HolderBonusesResponseFromJSON(json: any): HolderBonusesResponse {
  return HolderBonusesResponseFromJSONTyped(json, false)
}

export function HolderBonusesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HolderBonusesResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    items: !exists(json, 'items') ? undefined : (json['items'] as Array<any>).map(HolderBonusFromJSON),
  }
}

export function HolderBonusesResponseToJSON(value?: HolderBonusesResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    items: value.items === undefined ? undefined : (value.items as Array<any>).map(HolderBonusToJSON),
  }
}
